import { IconButton, Stack, Tooltip } from '@mui/material';
import { useState } from 'react';

export function download(
  data: BlobPart | undefined,
  filename: string,
  options: BlobPropertyBag
) {
  if (!data) {
    return;
  }

  const file = new Blob([data], options);
  const a = document.createElement('a');
  const url = URL.createObjectURL(file);
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  setTimeout(function () {
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }, 0);
}

export function columnsToBlob(data?: string[][], headerColumns?: string[]) {
  if (!data) return;

  const csvDataString = `${headerColumns?.join(',')}\n${data
    ?.map((row) => row.join(','))
    .join('\n')}`;
  return csvDataString;
}

export const DownloadButton = ({
  tooltip,
  onClick,
}: {
  tooltip: string;
  onClick: () => Promise<void>;
}) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [downloadSuccess, setDownloadSuccess] = useState(false);

  const handleClick = () => {
    setIsDownloading(true);
    void onClick()
      .then(() => {
        setDownloadSuccess(true);
        setTimeout(() => setDownloadSuccess(false), 2000); // Reset the tooltip after 2 seconds
      })
      .finally(() => {
        setIsDownloading(false);
      });
  };

  return (
    <Tooltip
      title={
        downloadSuccess ? (
          <Stack direction='row' alignItems='center' gap='4px'>
            <i className='material-symbols-check text-[18px]' /> Downloaded
          </Stack>
        ) : isDownloading ? (
          'Downloading...'
        ) : (
          tooltip
        )
      }
    >
      <span>
        <IconButton
          size='small'
          color='primary'
          onClick={handleClick}
          disabled={isDownloading}
        >
          <i className='material-symbols-download-rounded' />
        </IconButton>
      </span>
    </Tooltip>
  );
};
